import { useParams } from 'react-router-dom';

import { BookingConfirmation } from './Booking';

export const Confirmation = () => {
  const { slug } = useParams();

  return <BookingConfirmation slug={slug!} />;
};
